import { VStack } from "@whoosh/design-system/src/components/primitive";

import { BookingWizard } from "../../../../types";
import { MemberHoldCounter } from "./MemberHoldCounter";

type MemberListHeaderProps = {
  capacityOnBooking: number;
  rounds?: BookingWizard.BaseRound[];
};

export const MemberListHeader = ({
  capacityOnBooking,
  rounds,
}: MemberListHeaderProps) => {
  return (
    <VStack>
      <MemberHoldCounter
        capacityOnBooking={capacityOnBooking}
        rounds={rounds}
      />
    </VStack>
  );
};
